import { render } from "./CopyRight.vue?vue&type=template&id=6bf309f1&scoped=true"
const script = {}

import "./CopyRight.vue?vue&type=style&index=0&id=6bf309f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf309f1"]])

export default __exports__